export enum DayType {
    All = "All",
    WorkingDayOnly = "WorkingDayOnly",
    WorkingDay ="WorkingDay",
}
